import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/developer',
    name: 'developer',
    component: () => import(/* webpackChunkName: "developer" */ '../views/AboutDeveloper.vue')
  },
  {
    path: '/lineminiapp',
    name: 'lineminiapp',
    component: () => import(/* webpackChunkName: "lineminiapp" */ '../views/AboutLineminiapp.vue')
  },
  {
    path: '/t-kaishuu/:area', // 沼津、三島、長泉の出し分け用パラメータ
    name: 'area-kaishuu',
    component: () => import(/* webpackChunkName: "kaishuu" */ '../views/AreaKaishuuView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: routes
})

export default router
